// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2134":"716b3eeb","4320":"e41e529c","4879":"716b3eeb","8688":"c979e12a"}[chunkId] + ".chunk.css";
};